export const VERIFY_LOADING = 'VERIFY_LOADING'
export const VERIFY_TIME_ELAPSED = 'VERIFY_TIME_ELAPSED'
export const VERIFY_REQUEST = 'VERIFY_REQUEST'
export const VERIFY_CALL = 'VERIFY_CALL'